import { createFileRoute, redirect } from '@tanstack/react-router';

/** `/`: the front page when logged in, the login page otherwise (Angular's root resolver). */
export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    throw redirect({ href: context.session.status === 'authenticated' ? '/dashboard' : '/login' });
  },
});
